// Canonical 1-10 difficulty domain shared by the Overcalling Assign Level of
// Difficulty page (feature 012) and any future feature that needs a flat
// enumeration of the project's difficulty levels. The existing
// 003-difficulty-level-selector uses DIFFICULTY_CATEGORIES (named ranges) which
// is a different shape; this file is the first to publish the bare flat array.

export const DIFFICULTY_MIN = 1;
export const DIFFICULTY_MAX = 10;
export const DIFFICULTY_LEVELS: readonly number[] = Object.freeze(
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
);
